// Cross-context hand-off for the #693 welcome flow. A signup can complete in the toolbar popup page or
// the side panel (their own Redux stores), while the toast/chip/modal live in the WhatsApp Web content
// script. The forms stamp the time in chrome.storage.local; the content script picks it up.
import { SIGNUP_FLAG_KEY } from './ext-trial-logic';

export function stampSignupFlag(): void {
  try {
    chrome.storage?.local?.set({ [SIGNUP_FLAG_KEY]: Date.now() });
  } catch {
    // storage unavailable: the in-memory flag still covers a same-context signup
  }
}

export function readSignupFlag(): Promise<unknown> {
  return new Promise((resolve) => {
    try {
      chrome.storage.local.get(SIGNUP_FLAG_KEY, (items) => resolve(items?.[SIGNUP_FLAG_KEY]));
    } catch {
      resolve(undefined);
    }
  });
}

export function clearSignupFlag(): void {
  try {
    chrome.storage?.local?.remove(SIGNUP_FLAG_KEY);
  } catch {
    // ignore
  }
}

/** Calls `cb` whenever the flag is written. Returns an unsubscribe. */
export function onSignupFlag(cb: (value: unknown) => void): () => void {
  try {
    const listener = (changes: Record<string, chrome.storage.StorageChange>, area: string) => {
      if (area === 'local' && SIGNUP_FLAG_KEY in changes && changes[SIGNUP_FLAG_KEY].newValue !== undefined) {
        cb(changes[SIGNUP_FLAG_KEY].newValue);
      }
    };
    chrome.storage.onChanged.addListener(listener);
    return () => chrome.storage.onChanged.removeListener(listener);
  } catch {
    return () => undefined;
  }
}
